import { NavLink } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { buildPath } from '../lib/tenant';
import { getOrganiser } from '../lib/tickets';
import { t } from '../locales';

export function Footer() {
    const { data: organiser } = useQuery({
        queryKey: ['ticketing-organiser'],
        queryFn: getOrganiser,
        staleTime: 5 * 60 * 1000,
    });

    return (
        <footer style={{
            backgroundColor: 'var(--colour_menu_dark)',
            color: 'rgba(255,255,255,0.8)',
            marginTop: '4rem',
            padding: '2.5rem 1.5rem',
        }}>
            <div style={{
                maxWidth: 960,
                margin: '0 auto',
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
                gap: '2rem',
            }}>
                {/* Organiser info */}
                <div>
                    {organiser?.name && (
                        <p style={{ fontWeight: 700, color: '#fff', marginBottom: '0.5rem' }}>
                            {organiser.name}
                        </p>
                    )}
                    {organiser?.contact_email && (
                        <a
                            href={`mailto:${organiser.contact_email}`}
                            style={{ color: 'rgba(255,255,255,0.6)', fontSize: '0.875rem', display: 'block', marginBottom: '0.3rem' }}
                        >
                            {organiser.contact_email}
                        </a>
                    )}
                    {!organiser && (
                        <p style={{ color: 'rgba(255,255,255,0.5)', fontSize: '0.875rem' }}>
                            {t('footer.needHelp')}
                        </p>
                    )}
                </div>

                {/* Quick links */}
                <div>
                    <p style={{ fontWeight: 700, color: '#fff', marginBottom: '0.5rem' }}>
                        {t('footer.explore')}
                    </p>
                    <nav style={{ display: 'flex', flexDirection: 'column', gap: '0.3rem' }}>
                        <NavLink to={buildPath('/events')} style={{ color: 'rgba(255,255,255,0.6)', fontSize: '0.875rem', textDecoration: 'none' }}>
                            {t('footer.events')}
                        </NavLink>
                        <NavLink to={buildPath('/organiser')} style={{ color: 'rgba(255,255,255,0.6)', fontSize: '0.875rem', textDecoration: 'none' }}>
                            {t('footer.about')}
                        </NavLink>
                        <NavLink to={buildPath('/my-tickets')} style={{ color: 'rgba(255,255,255,0.6)', fontSize: '0.875rem', textDecoration: 'none' }}>
                            {t('footer.myTickets')}
                        </NavLink>
                    </nav>
                </div>

                {/* Help */}
                <div>
                    <p style={{ fontWeight: 700, color: '#fff', marginBottom: '0.5rem' }}>
                        {t('footer.help')}
                    </p>
                    <p style={{ color: 'rgba(255,255,255,0.6)', fontSize: '0.875rem', lineHeight: 1.6, margin: 0 }}>
                        {t('footer.helpBody')}
                    </p>
                </div>
            </div>

            <div style={{
                maxWidth: 960,
                margin: '2rem auto 0',
                borderTop: '1px solid rgba(255,255,255,0.1)',
                paddingTop: '1.25rem',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                flexWrap: 'wrap',
                gap: '0.5rem',
            }}>
                <span style={{ opacity: 0.4, fontSize: '0.8rem' }}>
                    &copy; {new Date().getFullYear()} {organiser?.name ?? t('footer.allRightsReserved')}
                </span>
                <span style={{ opacity: 0.4, fontSize: '0.8rem' }}>
                    {t('footer.poweredBy')}
                </span>
            </div>
        </footer>
    );
}

export default Footer;
